import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Typography, Tabs } from 'antd';

import Upload from '../upload/Upload';

import 'antd/dist/antd.css';
import styles from './ImportExchanges.css';

import { selectCurrent } from '../exchanges/exchangesSlice';

const { Title } = Typography;
const { TabPane } = Tabs;

export default function ImportExchanges() {
  const exchanges = useSelector(selectCurrent);

  return (
    <div>
      <div className={styles.container}>
        <Title level={5}>
          Import Transactions
        </Title>
        <Tabs defaultActiveKey="1">
          {exchanges.map(element => {
            if (element.active) {
              return (
                <TabPane tab={element.name} key={element.name}>
                  <Upload exchange={element.name} />
                </TabPane>
              );
            }
        })}
        </Tabs>
      </div>
    </div>
  );
}
